import { AxiosResponse } from 'axios';

import { Scraper } from '@/models/scraper';

import { api } from '.';

export const getScraperStatus = (): Promise<AxiosResponse<Scraper.Status>> =>
  api.get(`v2/status/scraping`);
